import CurrencyFormatter from "currency-formatter";

export default function Item({ name, data, bold = false, endLabel = false }) {
  return (
    <div className={`flex items-center mt-5 ${bold && "font-semibold"}`}>
      <div className="flex items-center" style={{ minWidth: "18em" }}>
        {name}
      </div>
      {data?.map((obj) => (
        <div className="flex" style={{ minWidth: "10em" }}>
          <div style={{ minWidth: obj?.disabled ? "4em" : "1.8em" }} />
          {
            obj?.disabled
            ? "--"
            : obj?.value < 0
              ? "(" + CurrencyFormatter.format(-obj?.value, { code: endLabel ? "" : "USD" }) + (endLabel || "") + ")"
              : CurrencyFormatter.format(obj?.value, { code: endLabel ? "" : "USD" }) + (endLabel || "")
          }
        </div>
      ))}
    </div>
  );
}
